import { Label } from 'views/components/atoms/label';
import { ListBodyCellType } from 'views/components/atoms/listCell';
import { BodyShowList } from 'views/components/molecules/listBody';
import { BgColors } from 'views/constants/enums/bgColors';
import { formatDate } from 'views/utils/format/FormatDate';
import { formatNumber } from 'views/utils/format/FormatNumber';
import { GetApplicationListQuery, GetApplicationListQueryVariables } from 'views/utils/graphql/graphql';

export const createBodyShowLists = (data: GetApplicationListQuery) => {
  if (!data.GetApplicationList?.Data) return [];

  const createdBodyShowLists: BodyShowList[] = data.GetApplicationList?.Data?.map((item) => [
    {
      type: ListBodyCellType.labelCell,
      label: <div>{item?.Status && checkStatusLabel(item?.Status)}</div>,
    },
    {
      type: ListBodyCellType.nameCell,
      label: <div>{item?.SymbolName}</div>,
    },
    {
      type: ListBodyCellType.amountCell,
      label: (
        <div>{`${formatNumber(Number(item?.TotalApplicationQuantity))} / ${formatNumber(
          Number(item?.TotalPurchaseQuantity),
        )} 口`}</div>
      ),
    },
    {
      type: ListBodyCellType.dateCell,
      label: <div>{formatDate(item?.LatestApplicationDateTime)}</div>,
    },
  ]);
  return createdBodyShowLists;
};

enum OrderStatus {
  One = '申込締切前',
  Two = '抽選前',
  Three = '抽選後',
  Four = '申込取消',
}

export const checkStatusLabel = (status: number) => {
  switch (status) {
    case 1:
      return <Label backgroundColor={BgColors.Safe} content={OrderStatus.One.toString()} />;
    case 2:
      return <Label backgroundColor={BgColors.Secondary} content={OrderStatus.Two.toString()} />;
    case 3:
      return <Label backgroundColor={BgColors.Primary} content={OrderStatus.Three.toString()} />;
    case 4:
      return <Label backgroundColor={BgColors.Danger} content={OrderStatus.Four.toString()} />;
  }
};
